import { valibotResolver } from "@hookform/resolvers/valibot";
import { PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerTitle,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useAudienceMutations from "../../../../datahooks/useAudienceMutations";
import { ProfileUrlSchema } from "../../../../schemas";

export default function AddTarget() {
  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useTwBreakpoint("lg");

  const { addTargetToCampaign, isAddingTargetToCampaign } =
    useAudienceMutations();

  const {
    handleSubmit,
    register,
    setError,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      url: "",
    },
    resolver: valibotResolver(ProfileUrlSchema),
  });

  function onSubmit(data: { url: string }) {
    addTargetToCampaign({ profileUrl: data.url })
      .then(() => {
        setIsOpen(false);
        reset();
      })
      .catch((err) => setError("url", { message: err.serverMessage }));
  }

  const Component = isDesktop ? Dialog : Drawer;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Title = isDesktop ? DialogTitle : DrawerTitle;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen} onAfterClose={reset}>
      <Trigger asChild>
        <Button
          leftIcon={<PlusCircle weight="fill" />}
          variant="outline-black"
          className="max-lg:flex-1"
        >
          Add new target
        </Button>
      </Trigger>

      <Content className="lg:w-[448px]">
        <Title className="mb-8">Add new target to a campaign</Title>

        <FormField
          label="Profile URL"
          htmlFor="profile_url"
          size="lg"
          error={errors.url?.message}
        >
          <Input
            id="profile_url"
            placeholder="Enter a LinkedIn URL here"
            variant="lg"
            {...register("url")}
          />
        </FormField>

        <div className="mt-8 flex flex-col gap-2 lg:flex-row-reverse lg:gap-4">
          <Button
            className="flex-1"
            size={isDesktop ? "lg" : "lg"}
            onClick={handleSubmit(onSubmit)}
            isLoading={isAddingTargetToCampaign}
          >
            Add target
          </Button>
          <Close asChild>
            <Button
              variant="secondary-black"
              className="flex-1"
              size={isDesktop ? "lg" : "lg"}
              onClick={() => setIsOpen(false)}
              disabled={isAddingTargetToCampaign}
            >
              Cancel
            </Button>
          </Close>
        </div>
      </Content>
    </Component>
  );
}
